(function (globalCore) {

  /**
  * Функции отвечающие за инициализацию агента.
  * @namespace Core.agent
  * @since 5.4.0.1005
  */
  globalCore.agent = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  var initializeAgentSession = function () {
    log.info('AGENT', '"InitializeAgentSession" function');

    //если записи в кэше о работе с агентом или без еще нет, то делаем ее в зависимости от поддерживаемости устройства
    if (!WA.agent.isDisableSetted() && !WA.agent.canUseInCurrentDevice()) {
      Core.agent.disable();
      log.info('AGENT', 'Agent is disabled for current device');
      return;
    }

    if (!WA.agent.isAvailable()) {
      log.info('AGENT', 'Agent is disabled in user settings');
      return;
    }

    if (g_IsAgentEnabled) {
      log.info('AGENT', 'Agent is enabled in web.config');
    } else {
      // Агент выключен в web.config.
      log.info('AGENT', 'Agent is disabled in web.config');
      return;
    }

    if (localStorage.getItem('agentHttpPort') !== null) {
      localStorage.removeItem('agentHttpPort');
      localStorage.removeItem('agentHttpsPort');
    }

    // Проверим запущен ли агент.
    WA.agent.checkSessionState(1).done(function (isSessionRegistered) {
      if (isSessionRegistered) {
        // Агент запущен.
        log.info('AGENT', 'Agent is started');

        // Если начнется обновление, то надо отобразить это в виджете.
        globalCore.agent.beforeUpdating(function () {
          globalCore.footer.agentNotStartedWidget.show();
        });

        _initSession()
            .then(_updateAgent)
            .then(_initAgentUI);
      }
    }).fail(function (isSessionError) {
      if (isSessionError) {
        log.info("AGENT", "Try start with URI");
        // Некорректный ИД сессии, запускаем по URI
        start();
      } else {
        // Агент не запущен.
        log.info('AGENT', 'Agent is NOT started');

        // Не показываем виджет агента
        //// Запуск
        //var eventName = globalCore.footer.agentNotStartedWidget['class'].EVENT.AFTER_START;
        //globalCore.footer.agentNotStartedWidget.bind(eventName, function () {
        //  _initSession()
        //    .then(_updateAgent)
        //    .then(_initAgentUI);
        //});

        //// Скачивание
        //var eventName = globalCore.footer.agentNotStartedWidget['class'].EVENT.AFTER_DOWNLOAD;
        //globalCore.footer.agentNotStartedWidget.bind(eventName, showDownloadInstruction);

        //// Диалог может и не показаться, если его закрыл пользователь, такая уж у него логика.
        //globalCore.footer.agentNotStartedWidget.show();
      }
    });
  };

  function UpdateAgentProgressBar(dialog, progress) {
    $('#progress-bar').animate({ width: progress + '%' }, 1000);
  }

  function GetProgressBarHtml() {
    var html = '<div>' + L("AGENT_IS_BEING_UPDATED") + '</div><div id="progress-container"><div id="progress-bar"></div></div>';
    return html;
  }


  // Функция вызываемая после запуска агента.
  function afterStartAgent() {
    log.info('AGENT', '"afterStartAgent" function was called');

    return _initSession().then(_initAgentUI);
  };

  // Функция вызываемая после скачивания агента.
  function showDownloadInstruction(platform) {
    if (platform) {
      // TODO Если будем делать инструкцию. 
    } else {
      // TODO Если будем делать инструкцию.
    }
  };

  // Проверить, нужно ли отобразить какие-то уведомления. 
  function checkNotifications() {
    // Показать инструкцию, если агент был отключен. 
    if (needShowInstruction()) {
      showEnableInstruction();
    }
  };

  // Нужно ли показать toast с инструкцией
  function needShowInstruction() {
    if (WA.agent.canUseInCurrentDevice()) {
      var needShow = WA.cache.getItem('agent.needShowInstruction');
      WA.cache.setItem('agent.needShowInstruction', null);
      return needShow == "1";
    }

    return false;
  };

  function showEnableInstruction() {
    var toast = new WA.CMP.NTF.Toast();
    toast.showMessage(L("WORK_WITHOUT_AGENT_INSTRUCTION"), true);
    // Ссылка для перехода в настройки
    $(".toast_settings-link").click(function () {
      window.open("/Settings.aspx", 'settings');
    });
  }

  /**
   * Вызвать действие через агент.
   *
   * @param {string} requestName Наименование запроса.
   * @param {string} pluginName Имя плагина.
   * @param {Object} params Параметры запроса.
   * @return {Deferred<Object>} Результат выполнения запроса.
   * @see https://api.jquery.com/category/deferred-object/
   */
  function invoke(requestName, pluginName, params) {
    var def = $.Deferred();

    // Запрос к агенту
    function request(requestName, pluginName, params) {
      WA.agent.transmitRequest(requestName, pluginName, params).done(function (res) {
        def.resolve(res);
      }).fail(function (res) {
        def.reject(res);
      });
    };

    WA.agent.checkSessionState(1).done(function () {
      // Если агент запущен - выполняем действие 
      request(requestName, pluginName, params);
    }).fail(function (isSessionError) {
      if (isSessionError) {
        log.info("AGENT", "Try start with URI");
        // Некорректный ИД сессии, запускаем по URI
        start();
      } else {
        // Если нет - отображаем диалог запуска. 
        var dialog = new globalCore.agent.RunWithAgentDialog();
        dialog.agentAction = function () {
          request(requestName, pluginName, params);
        };
        dialog.show();
      }
    });

    return def.promise();
  }

  /**
   * Получить объект для выполнения запросов к плагину.
   *
   * @function getPlugin
   * @param {string} pluginName Имя плагина.
   * @return {Deferred<Object>} объект для выполнения запросов к плагину.
   * @see https://api.jquery.com/category/deferred-object/
   *
   * @example
   * Core.agent.getPlugin('edmsPlugin').done(function (plugin) {
   *   plugin.invoke('opendocument', params).done(...);
   * });
   */
  function getPlugin(pluginName) {
    var def = $.Deferred();
    var pluginObj = {
      invoke: function (method, params) {
        return invoke(method, pluginName, params);
      }
    };

    function _getPlugin() {
      WA.agent.isPluginAvailable(pluginName).done(function (isAvailable) {
        isAvailable ? def.resolve(pluginObj) : def.reject();
      }).fail(function (err) {
        // Если не удалось получить значение, то отображаем диалог запуска и выполняем проверку еще раз. 
        showDialog();
      });
    };

    function showDialog() {
      var dialog = new globalCore.agent.RunWithAgentDialog();
      dialog.agentAction = function () {
        WA.agent.isPluginAvailable(pluginName).done(function (isAvailable) {
          isAvailable ? def.resolve(pluginObj) : def.reject();
        }).fail(function (err) {
          def.reject(err);
        });
      };
      dialog.show();
    }

    var defForSession = $.Deferred();
    WA.agent.checkSessionState().done(function (isSessionRegistered) {
      //Если сессия зарегистрирована, но не проинициализирована то вызываем beginSession
      if (!WA.agent.isSessionInitialized())
        WA.agent.beginSession().done(function () {
          log.info('AGENT', 'Agent session is initialized.');
          WA.agent.setSessionInitialized(true);
          defForSession.resolve(isSessionRegistered);
        }).fail(function () {
          defForSession.reject(true);
        });
      else defForSession.resolve(isSessionRegistered);
    }).fail(function (isSessionError) {
      defForSession.reject(isSessionError);
    });

    // Проверим, запущен ли агент и зарегистрирована ли сессия.
    defForSession.done(function (isSessionRegistered) {
      if (isSessionRegistered) {
        // Агент запущен.
        log.info('AGENT', 'Agent is started');
        _getPlugin();
      }
    }).fail(function (isSessionError) {
      if (isSessionError) {
        log.info("AGENT", "Try start with URI");
        // Некорректный ИД сессии, запускаем по URI
        start().done(function () {
          _getPlugin();
        });
      } else {
        // Агент не запущен - отобразится диалог запуска. 
        showDialog();
      }
    });

    return def.promise();
  }

  /**
   * Запуск приложения
   *
   * @function _startAgent
   * @return {Deferred<void>}
   * @private
   * @see https://api.jquery.com/category/deferred-object/
   */
  function _startAgent() {
    var def = $.Deferred();

    log.info('AGENT', 'Agent starting by URL scheme...');
    var startDef = WA.agent.start().done(function (isStarted) {
      if (isStarted) {
        log.info('AGENT', 'Agent started');
        def.resolve();
      } else {
        log.info('AGENT', 'Agent is running in another windows session');
        def.reject(L('AGENT_RUNNING_IN_AHOTHER_WINDOWS_SESSION_ADDITIONAL_TEXT'));
      }
    }).fail(function (err) {
      // Не запустился timeout или oldagent.
      log.info('AGENT', 'Agent NOT started. Error code = ' + err);
      // Если запуск был отменен, то не отображаем сообщения об ошибке.
      var text = err === 'canceled' ? "" : L('AGENT_WAITING_START_FAIL');
      def.reject(text);
    });

    return def.promise();
  }

  /**
   * Обновить агент.
   *
   * @function _updateAgent
   * @return {Deferred<Object>} Результат инициализации.
   * @private
   * @see https://api.jquery.com/category/deferred-object/
   */
  function _updateAgent() {
    const CHECK_STATE_INTERVAL = 2000;

    let def = $.Deferred();
    let errCount = 0;
    let checkStateAttemptsLimit = 5;

    // Проверка состояния обновления 
    function checkUpdateState() {
      WebAccess.agent.updates.getUpdateProgress().done(function (resp) {
        if (resp.success) {
          $.event.trigger(globalCore.agent.EVENT.ON_UPDATING, resp.result);
          if (resp.result === 100) {

            // Как только обновления агента скачаны, начинаем крутить спиннер на перезапуск агента
            $.event.trigger(globalCore.agent.EVENT.AFTER_UPDATING, resp.result);
            WA.CR.spinner.show();
            const checkAgentInterval = setInterval(() => {
              WA.agent.checkSessionState(1).done(() => {
                WA.CR.spinner.hide();
                // Агент успешно перезапустился
                $.event.trigger(globalCore.agent.EVENT.AFTER_UPDATING_RESTARTED, resp.result);
                clearInterval(checkAgentInterval);
                // Инициализируем сессию
                _initSession().done(function () {
                    def.resolve(resp.result);
                });
              }).fail(() => {
                checkStateAttemptsLimit--;

                // Если агент не запустился сам, то попросим об этом пользователя.
                if (!checkStateAttemptsLimit) {
                  // Скрываем спиннер
                  window.log.info('AGENT', 'Agent failed to start after update');
                  WA.CR.spinner.hide();
                  $.event.trigger(globalCore.agent.EVENT.AFTER_UPDATING_RESTARTED, resp.result);
                  clearInterval(checkAgentInterval);
                  
                  // Показываем модальный диалог с сообщением об ожидании запуска агента
                  var dialog = new globalCore.agent.WaitAgentRunDialog();
                  dialog.completeAction = function () {
                    // Инициализируем сессию
                    _initSession().done(function () {
                      def.resolve(resp.result);
                    });                  
                  };
                  dialog.show();                  
                }
              });
            }, CHECK_STATE_INTERVAL);
          } else if (resp.result === -1) {
            //сюда попадаем, если агент начал обновляться, но не может завершить обновление до конца
            //если сделать reject, ВД не прекратит попытки обновляться, поэтому resolve
            log.info("AGENT", "Agent cannot finish updating");
            def.resolve();
          } else {
            setTimeout(checkUpdateState, CHECK_STATE_INTERVAL);
          }
        }
      }).fail(function (err) {
        errCount += 1;
        log.info("AGENT", "Agent getUpdateProgress error count: " + errCount);
        if (errCount > 2) {
          $.event.trigger(globalCore.agent.EVENT.ON_FAIL_UPDATING, err.result);
          def.reject(err.message);
        } else {
          setTimeout(checkUpdateState, CHECK_STATE_INTERVAL);
        }
      });
    }

    WebAccess.agent.updates.checkUpdates().done((response) => {
      if (response == 'YES') {
        $.event.trigger(globalCore.agent.EVENT.BEFORE_UPDATING);
        setTimeout(checkUpdateState, CHECK_STATE_INTERVAL);
      }
    }).fail((response) => {
      if (response == 'SKIPPED') {
        log.info('AGENT', L('AGENT_UPDATE_SKIPPED'))
      }
      def.resolve();
    });

    return def.promise();
  }

  /**
   * Инициализировать сессию.
   *
   * @function _initSession
   * @return {Deferred<void>}
   * @private
   * @see https://api.jquery.com/category/deferred-object/
   */
  function _initSession() {
    var def = $.Deferred();

    log.info('AGENT', 'Agent session is initializing...');
    WA.agent.beginSession().done(function () {
      log.info('AGENT', 'Agent session is initialized.');
      WA.agent.setSessionInitialized(true);
      def.resolve();
    }).fail(function (err) {
      log.info('AGENT', 'Agent session failed.');
      def.reject(err);
    });

    return def.promise();
  }

  /**
   * Инициализировать виджет открытия документов.
   *
   * @function _initAgentUI
   * @return {Deferred<void>}
   * @private
   * @see https://api.jquery.com/category/deferred-object/
   */
  function _initAgentUI() {
    var def = $.Deferred();
    if (WA.getLocation() === 'explorer') {
      // Скрываем виджет о необходимости запустить агента.
      globalCore.footer.agentNotStartedWidget.hide();
      //Проверяем наличие редактируемых документов
      globalCore.footer.openedDocumentsWidget.init();
    }
    def.resolve();

    return def.promise();
  }

  // Запуск агента
  function start() {
    return _startAgent()
      .then(_initSession)
      .then(_updateAgent)
      .then(_initAgentUI);
  };

  function cancelStart() {
    log.info('AGENT', 'Agent is not starting');
    WA.agent.cancelStart();
  };

  /**
   * Загрузить агент.
   *
   * @function download
   * @return {Deferred<void>}
   * @see https://api.jquery.com/category/deferred-object/
   */
  function download() {
    var def = $.Deferred();

    var platform = WA.ENV.platform;
    if (platform === 'linux') {

      var downloadDebPackageButton = {
        id: "deb",
        text: L('AGENT_DOWNLOAD_DEB_PACKAGE_NAME'),
        click: function () {
          WA.agent.download('linux_deb');
          def.resolve();
        }
      };
      var downloadRpmPackageButton = {
        id: "rpm",
        text: L('AGENT_DOWNLOAD_RPM_PACKAGE_NAME'),
        click: function () {
          WA.agent.download('linux_rpm');
          def.resolve();
        }
      };

      var dialog = new WebAccess.components.dialogs.BaseDialog({
        title: L('AGENT_DOWNLOAD_LINUX_PACKAGE_INSTRUCTION_TITLE'),
        isShowOkButton: false,
        isShowCancelButton: true,
        width: '415px'
      });
      dialog.setHtml(L('AGENT_DOWNLOAD_LINUX_PACKAGE_INSTRUCTION'));
      dialog.modalWindowButtons.push(downloadDebPackageButton);
      dialog.modalWindowButtons.push(downloadRpmPackageButton);
      dialog.show();


    } else {
      WA.agent.download();
      def.resolve();
    }

    return def.promise();
  }

  function disable() {
    WA.agent.disable();
    Core.settings.saveDocDefaultActionSettings().always(function () {
      // Установить значение в кэше, чтобы отобразить toast с инструкцией после перезагрузки странцицы.
      WA.cache.setItem('agent.needShowInstruction', '1');
      window.location.reload();
    });
  };

  function bind(event, handler) {
    // Обработчики можно добавить только к своим событиям 
    if (_.contains(_.values(globalCore.agent.EVENT), event)) {
      $(document).on(event, handler);
    }
  };

  function unbind(event, handler) {
    // Обработчики можно убрать только у своих событий
    if (_.contains(_.values(globalCore.agent.EVENT), event)) {
      $(document).off(event, handler);
    }
  }

  // ---------------------------------------------------------------------------------------------------
  //                                          Public functions
  // ---------------------------------------------------------------------------------------------------

  globalCore.agent = {
    // События агента
    EVENT: {
      BEFORE_UPDATING: 'beforeAgentUpdating',
      ON_UPDATING: 'onAgentUpdating',
      AFTER_UPDATING: 'afterAgentUpdating',
      ON_FAIL_UPDATING: 'onFailAgentUpdating',
      AFTER_UPDATING_RESTARTED: 'afterAgentUpdatingRestarted'
    },

    /**
    * Инициализировать сессию агента.
    *
    * @method Core.agent.init
    */
    init: initializeAgentSession,

    /**
    * Проверить сообщения для отоборажения в веб досупе. 
    *
    * @method Core.agent.checkNotifications
    */
    checkNotifications: checkNotifications,

    /**
    * Вызвать действие через агент.
    *
    * @method Core.agent.invoke
    * @return {$.Deferred} Deferred-объект.
    */
    invoke: invoke,

    /** 
    * Запуск агента.
    *
    * @method Core.agent.start
    * @return {$.Deferred} Deferred-объект.
    */
    start: start,

    /** 
    * Отменить запуск агента. Функция изменяется в зависимости от шага выполнения. 
    *
    * @method Core.agent.cancelStart
    */
    cancelStart: cancelStart,

    /**
    * Скачать агент.
    *
    * @method Core.agent.download
    * @return {$.Deferred} Deferred-объект.
    */
    download: download,

    /**
    * Включить уведомление для отключеннго агента. 
    *
    * @method Core.agent.disable
    */
    disable: disable,

    /**
    * Получить объект для выполнения запросов к плагину.
    *
    * @method Core.agent.getPlugin
    * @return {$.Deferred} Deferred-объект.
    *
    * @example 
    * Core.agent.getPlugin('edmsPlugin').done(function (plugin) { 
    *   plugin.invoke('opendocument', params).done(...); 
    * }).fail(...);
    */
    getPlugin: getPlugin,

    /**
    * Навесить обработчик на событие. 
    * @method Core.agent.bind
    *
    */
    bind: bind,

    /**
    * Убрать обработчик события. 
    * @method Core.agent.unbind
    *
    */
    unbind: unbind,

    /**
    * Навесить обработчик на событие "До обновления агента". 
    * @method Core.agent.beforeUpdating
    *
    */
    beforeUpdating: function (handler) {
      globalCore.agent.bind(globalCore.agent.EVENT.BEFORE_UPDATING, handler);
    },

    /**
    * Навесить обработчик на событие "Обновление агента". 
    * @method Core.agent.onUpdating
    *
    */
    onUpdating: function (handler) {
      globalCore.agent.bind(globalCore.agent.EVENT.ON_UPDATING, handler);
    },

    /**
    * Навесить обработчик на событие "После обновления агента". 
    * @method Core.agent.afterUpdating
    *
    */
    afterUpdating: function (handler) {
      globalCore.agent.bind(globalCore.agent.EVENT.AFTER_UPDATING, handler);
    },

    /**
    * Навесить обработчик на событие "Ошибка обновления агента". 
    * @method Core.agent.onFailUpdating
    *
    */
    onFailUpdating: function (handler) {
      globalCore.agent.bind(globalCore.agent.EVENT.ON_FAIL_UPDATING, handler);
    },

    /**
     * Навесить обработчик на событие "После обновления агента рестартован".
     * @method Core.agent.afterUpdatingRestarted
     *
     */
    afterUpdatingRestarted: function (handler) {
      globalCore.agent.bind(globalCore.agent.EVENT.AFTER_UPDATING_RESTARTED, handler);
    },
  };

})(window.Core);
